export const Device = Object.freeze({
  XS: 480, // Extra small devices (phones)
  SM: 600, // Small devices (tablets)
  MD: 900, // Medium devices (desktops)
  LG: 1200, // Large devices (large desktops)
  XL: 1920, // Extra large devices (large desktops and TVs)
});
